import {
  loadCropsDetails,
  loadExistingEquipment,
  loadNewlyAddedEquipmentDetails,
} from './digidiary.service';
import {getContractsArray, getCustomerId} from './selectors';

import {serializeAndMergeEquipment} from '../../component/DigiDiary/digiDiaryUtil/digiDiaryUtil';
import {
  DD_LOAD_EXISTING_EQUIPMENT,
  DD_LOAD_MY_FARM_VIEW,
  DD_PUT_EXISTING_EQUIPMENT_DATA,
  DD_PUT_MY_FARM_DATA,
  DD_SET_MY_FARM_DATA_LOADING,
} from '../actions';
import {setAllEquipment} from '../actions/digiDiaryActions';

import {all, put, select, takeEvery} from 'redux-saga/effects';

export function* loadMyFarmData() {
  let myFarmLoading = true;
  yield put({type: DD_SET_MY_FARM_DATA_LOADING, myFarmLoading});
  const customerId = yield select(getCustomerId);
  let loadCrops = [],
    newlyAddedEquipmentDetails = [],
    existingEquipment;

  loadCrops = yield loadCropsDetails(customerId);

  newlyAddedEquipmentDetails = yield loadNewlyAddedEquipmentDetails(customerId);

  const contractsArray = yield select(getContractsArray);
  existingEquipment = yield all(
    contractsArray.map((contracts) =>
      loadExistingEquipment(customerId, contracts.contractNumber)
    )
  );

  const dataObj = {
    crops: loadCrops?.data,
    equipments: newlyAddedEquipmentDetails?.data,
    existingEquipments: existingEquipment,
  };

  yield put({type: DD_PUT_MY_FARM_DATA, dataObj});
  myFarmLoading = false;
  yield put({type: DD_SET_MY_FARM_DATA_LOADING, myFarmLoading});
}

export function* loadExistingEquipmentFromMFA() {
  let myFarmLoading = true;
  yield put({type: DD_SET_MY_FARM_DATA_LOADING, myFarmLoading});
  const customerId = yield select(getCustomerId);
  let existingEquipment = [];
  const contractsArray = yield select(getContractsArray);
  existingEquipment = yield all(
    contractsArray.map((contracts) =>
      loadExistingEquipment(customerId, contracts.contractNumber)
    )
  );
  const dataObj = {
    existingEquipments: existingEquipment,
  };
  const allEquipments = serializeAndMergeEquipment(
    [],
    existingEquipment,
    customerId
  );
  yield put({type: DD_PUT_EXISTING_EQUIPMENT_DATA, dataObj});
  yield put(setAllEquipment(allEquipments));
  myFarmLoading = false;
  yield put({type: DD_SET_MY_FARM_DATA_LOADING, myFarmLoading});
}

export function* loadMyFarmView() {
  yield takeEvery(DD_LOAD_EXISTING_EQUIPMENT, loadExistingEquipmentFromMFA);
  yield takeEvery(DD_LOAD_MY_FARM_VIEW, loadMyFarmData);
}
